import React from 'react'
import AccountMenuItem from './AccountMenuItem'
import { cn } from '../../lib/utils'

const AccountMenuList = ({
  items = [],
  activeId,
  variant = 'list',
  onAction,
  className
}) => {
  return (
    <nav
      className={cn(
        variant === 'sidebar' ? 'flex flex-col gap-1' : 'flex flex-col',
        className
      )}
      aria-label="Account"
    >
      {items.map(item => (
        <AccountMenuItem
          key={item.id}
          item={item}
          active={activeId === item.id}
          variant={variant}
          onAction={onAction}
        />
      ))}
    </nav>
  )
}

export default AccountMenuList
